import React, { useState } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

import Modal from '../../Components/UI/Modal/Modal';
import { refuseTheVisit, validateTheVisit } from '../../Store/Actions/actionOffer';

const ManageEstimationModal = ({
  showModal,
  handleClick,
  demand,
  loading,
  acceptFunction,
  rejectFunction,
}) => {
  const [submitting, setSubmitting] = useState('');
  const estimation = demand?.estimation;
  const artisanConfirmed = Boolean(demand?.visit_confirmation?.artisan_confirmed_at);
  const opened = showModal === 'open';

  const close = () => {
    if (!submitting) handleClick?.();
  };

  const submit = async (decision) => {
    if (!demand || submitting) return;
    setSubmitting(decision);
    const success = decision === 'accept'
      ? await acceptFunction(demand)
      : await rejectFunction(demand);
    setSubmitting('');
    if (success) handleClick?.();
  };

  return (
    <Modal opened={opened} close={close}>
      <Header>
        <div>
          <Eyebrow>Après la visite</Eyebrow>
          <Title>Souhaitez-vous poursuivre avec cet artisan&nbsp;?</Title>
        </div>
        <CloseButton type="button" aria-label="Fermer" onClick={close}>×</CloseButton>
      </Header>

      <Artisan>
        <Avatar src={estimation?.artisan_profile_image || '/images/user.svg'} alt="" />
        <div>
          <strong>
            {[estimation?.artisan_firstname, estimation?.artisan_lastname]
              .filter(Boolean)
              .join(' ') || 'Artisan inconnu'}
          </strong>
          <span>{artisanConfirmed ? 'L’artisan a confirmé sa présence. Vérifiez que la visite a bien eu lieu.' : 'L’artisan doit d’abord confirmer sa présence à la visite.'}</span>
        </div>
      </Artisan>

      <Explanation>
        {artisanConfirmed
          ? 'Votre confirmation commune autorise l’artisan à préparer et envoyer le devis détaillé. En cas de problème, ne confirmez pas et contactez-le dans la conversation.'
          : 'Aucune action n’est requise pour le moment. Dès que l’artisan confirme la visite, vous pourrez confirmer à votre tour ou signaler que vous ne souhaitez pas poursuivre.'}
      </Explanation>

      <Actions>
        <SecondaryButton
          type="button"
          disabled={loading || Boolean(submitting)}
          onClick={() => submit('reject')}
        >
          {submitting === 'reject' ? 'Refus en cours…' : 'Ne pas poursuivre'}
        </SecondaryButton>
        <PrimaryButton
          type="button"
          disabled={loading || Boolean(submitting) || !artisanConfirmed}
          onClick={() => submit('accept')}
        >
          {submitting === 'accept' ? 'Confirmation…' : artisanConfirmed ? 'Confirmer la visite' : 'En attente de l’artisan'}
        </PrimaryButton>
      </Actions>
    </Modal>
  );
};

const Header = styled.header`display: flex; align-items: flex-start; justify-content: space-between; gap: 1rem;`;
const Eyebrow = styled.div`margin-bottom: 0.35rem; color: #a88a5d; font-size: 0.78rem; font-weight: 900; letter-spacing: 0.12em; text-transform: uppercase;`;
const Title = styled.h2`margin: 0; color: #111111; font-size: clamp(1.35rem, 4vw, 1.9rem);`;
const CloseButton = styled.button`width: 2.5rem; height: 2.5rem; flex: 0 0 auto; border: 0; border-radius: 50%; background: #f1ece5; color: #111111; font: inherit; font-size: 1.6rem; cursor: pointer;`;
const Artisan = styled.div`
  display: flex; align-items: center; gap: 0.9rem; margin-top: 1.4rem; padding: 1rem;
  border: 1px solid #e5e1da; border-radius: 1rem; background: #faf8f4;
  div { display: grid; gap: 0.2rem; } span { color: #726b61; font-size: 0.88rem; line-height: 1.45; }
`;
const Avatar = styled.img`width: 3.4rem; height: 3.4rem; flex: 0 0 auto; border-radius: 50%; object-fit: cover; background: #efede8;`;
const Explanation = styled.p`margin: 1.1rem 0 0; padding: 1rem; border-radius: 0.9rem; background: #f4ede1; color: #8a6f48; line-height: 1.6;`;
const Actions = styled.div`display: flex; justify-content: flex-end; gap: 0.75rem; margin-top: 1.5rem; @media (max-width: 520px) { flex-direction: column-reverse; }`;
const BaseButton = styled.button`min-height: 2.8rem; padding: 0.75rem 1.15rem; border-radius: 999px; font: inherit; font-weight: 800; cursor: pointer; &:disabled { opacity: 0.55; cursor: wait; }`;
const SecondaryButton = styled(BaseButton)`border: 1px solid #e7dfd2; background: #fff; color: #9a2f29;`;
const PrimaryButton = styled(BaseButton)`border: 1px solid #c0a375; background: #c0a375; color: #111111;`;

const mapStateToProps = ({ demands }) => ({ loading: demands?.loading });
const mapDispatchToProps = (dispatch) => ({
  acceptFunction: (demand) => dispatch(validateTheVisit(demand)),
  rejectFunction: (demand) => dispatch(refuseTheVisit(demand)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ManageEstimationModal);
